export const CASE_DETAIL_HEADER = [
  {
    value: 'case_id',
    label: 'Case Id',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'Qty',
  },
  {
    value: 'received',
    label: 'Received',
  },
  {
    value: 'completed',
    label: 'Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  
  {
    value: '',
    label: 'Med Cvge',
  },
  {
    value: '',
    label: 'Med PA',
  },
  {
    value: 'case_status',
    label: 'Case Status',
  },
  {
    value: '',
    label: 'Update',
  },
  
  {
    value: 'provider.doc_name',
    label: 'Provider',
  },
];
export const CASE_DETAIL_HEADER_DOC_STATS = [
  {
    value: 'case_id',
    label: 'Case Id',
  },
  {
    value: '',
    label: 'Qty',
  },
  {
    value: 'received',
    label: 'Received',
  },
  {
    value: 'completed',
    label: 'Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  {
    value: "",
    label: "Outcome"
  },
  {
    value: '',
    label: 'Rx Coverage',
  },
  {
    value: '',
    label: 'Med Coverage',
  },
  {
    value: '',
    label: 'Rx PA',
  },
  {
    value: '',
    label: 'Med PA',
  },
  {
    value: '',
    label: 'Case Status',
  },
  {
    value: '',
    label: 'Network Status',
  },
  
  {
    value: 'provider.doc_name',
    label: 'Provider',
  },
];

export const ONGOING_TREATMENTS_HEADER = [
  {
    value: 'case_id',
    label: 'Case Id',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'Bi',
    label: 'BI #',
  },
  {
    value: 'qty',
    label: 'Qty',
  },
 
  {
    value: 'Prevous_treatment_date',
    label: 'Prevous Treatment Date',
  },
  {
    value: 'payer',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Outcome',
  },
  {
    value: '',
    label: 'Rx Cvge',
  },
  {
    value: '',
    label: 'Med Cvge',
  },
  {
    value: '',
    label: 'Rx PA',
  },
  {
    value: '',
    label: 'Med PA',
  },
  {
    value: 'case_status',
    label: 'Case Status',
  },
  {
    value: '',
    label: 'Type',
  },
  {
    value: 'provider',
    label: 'provider',
  },
];


export const PROVIDER_PRACTICES_HEADER = [
  {
    value: '',
    label: 'Providers',
  },
  {
    value: '',
    label: 'Commercial',
  },
  {
    value: '',
    label: 'Medicare',
  },

  {
    value: '',
    label: 'Unspecified',
  },
  {
    value: '',
    label: 'Total Cases',
  },
  
];
